import { Typography, Box, useTheme } from "@mui/material";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const primaryDark = theme.palette.primary.dark;  
  const neutralDark = theme.palette.neutral.darkest;

  return (
    <Box display="flex" flexDirection="column" gap={1} sx={{ mb: "10px" }}>
      <Typography
        variant="h4"
        color={primaryDark}
      >
        {title}
      </Typography>
      <Typography 
        variant="h5" 
        color={neutralDark}        
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
